import Parse from "parse";

import type { Ticket } from "./Ticket";
import type { _User } from "./_User";

type OD3_Tenant = Parse.Object;

export interface Ticket_MaterialAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  itemList: any[];
  tenant?: OD3_Tenant;
  ticket: Ticket;
  user?: _User;
}

export class Ticket_Material extends Parse.Object<Ticket_MaterialAttributes> {
  static className: string = "OD3_Maintenance_Ticket_Material";

  constructor(data?: Partial<Ticket_MaterialAttributes>) {
    super("OD3_Maintenance_Ticket_Material", data as Ticket_MaterialAttributes);
  }

  get itemList(): any[] {
    return super.get("itemList");
  }
  set itemList(value: any[]) {
    super.set("itemList", value);
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get ticket(): Ticket {
    return super.get("ticket");
  }
  set ticket(value: Ticket) {
    super.set("ticket", value);
  }
  get user(): _User | undefined {
    return super.get("user");
  }
  set user(value: _User | undefined) {
    super.set("user", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Ticket_Material", Ticket_Material);
